import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  SchedulerDto,
} from '../../../../api/api-reference';
import { CronPipe } from "../../../../pipes/cron";

@Component({
  selector: 'app-scheduler-details',
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularSvgIconModule, CronPipe],
  templateUrl: './scheduler-details.component.html',
  styleUrl: './scheduler-details.component.scss',
})
export class SchedulerDetailsComponent implements OnInit {
  @Input() reminderId: string = '';
  @Output() close = new EventEmitter<boolean>();
  reminder: SchedulerDto = new SchedulerDto();

  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) { }

  get assetTypeNames(): string[] {
    return (this.reminder?.assetTypes?.map(assetType => assetType.name ?? "") || []);
  }

  get meterModelNames(): string[] {
    return (this.reminder?.meterModels?.map(meterModel => meterModel.model ?? "") || []);
  }

  ngOnInit(): void {
    this.getScheduleById();
  }

  toggleModal() {
    this.close.emit();
  }

  getScheduleById() {
    this.client.getReminder(this.reminderId).subscribe({
      next: (result) => {
        this.reminder = result;
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}